import { render, staticRenderFns } from "./addtocartButton.vue?vue&type=template&id=c903fae6&scoped=true&"
import script from "./addtocartButton.vue?vue&type=script&lang=js&"
export * from "./addtocartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c903fae6",
  null
  
)

export default component.exports